import React, {PureComponent} from "react";

class PlanHeader extends PureComponent {

    state = {
        planId: this.props.planId,
        price: this.props.price,
        planName: this.props.planName,
        planPeriod: this.props.planPeriod,
        selectedPlanId: this.props.selectedPlanId,
        spinnerActive: this.props.spinnerActive,
        spinnerActivePlan: this.props.spinnerActivePlan
    }


    componentDidUpdate = () => {
        if (this.state.planId !== this.props.planId) {
            this.setState({
                planId: this.props.planId
            })
        }
        if (this.state.planName !== this.props.planName) {
            this.setState({
                planName: this.props.planName
            })
        }
        if (this.state.price !== this.props.price) {
            this.setState({
                price: this.props.price
            })
        }
        if (this.state.selectedPlanId !== this.props.selectedPlanId) {
            this.setState({
                selectedPlanId: this.props.selectedPlanId
            })
        }
        if (this.state.spinnerActive !== this.props.spinnerActive) {
            this.setState({
                spinnerActive: this.props.spinnerActive
            })
        }
        if (this.state.spinnerActivePlan !== this.props.spinnerActivePlan) {
            this.setState({
                spinnerActivePlan: this.props.spinnerActivePlan
            })
        }
    }
    renderDescriptionSwitch = (param) => {
        switch (param) {
            case 'Tester':
                return ('Easiest way to get started and test the platform.');
            case 'Starter':
                return ('Perfect for small customer base.');
            case 'Essentials':
                return ('All the Essentials for high performing campaigns.');
            case 'Boost':
                return ('Heavy guns, with all the bells and whistles.');
        }
    }

    renderSaveSwitch = (param) => {
        switch (param) {
            case 'Tester':
                return ('48');
            case 'Starter':
                return ('120');
            case 'Essentials':
                return ('240');
            case 'Boost':
                return ('600');
        }
    }

    render() {
        const amount = this.state.planPeriod === 'monthly' ? Number(this.state.price.replace("$", "")) : Number(this.state.price.replace("$", "")) * 12
        // console.log('PlanHeader - amount: ', amount)
        // console.log('planHeader state: ', this.state)
        return (
            <div className="px-4 py-5 relative">
                {this.state.planName === 'Essentials' ?
                    <div
                        className="bg-green absolute font-semibold text-xs -top-4 bg-darkText text-white py-1 px-2 rounded-md">
                        MOST POPULAR
                    </div> :
                    ''
                }
                <h2 className="cardHeader">{this.state.planName}</h2>
                <p className="mt-4 text-sm min-h-[40px]">{this.renderDescriptionSwitch(this.state.planName)}</p>
                <p className="mt-8">
                    <span
                        className="text-4xl font-extrabold text-darkText w-[91px] testerPrice">${this.state.price.replace("$", "")}</span>

                    <span
                        className="text-base font-medium">/mo{this.state.planPeriod === 'yearly' ? ', billed yearly' : ''}</span>
                </p> {/* Button */}

                <button
                    disabled={this.state.spinnerActive && this.state.spinnerActivePlan === this.state.planId}
                    onClick={
                        this.state.planId === this.state.selectedPlanId ? '' :
                            () => this.props.handlePremiumPlan(amount, this.state.planId)}
                    className="getStartedButton"

                    id={this.state.planId.replace(/_([a-z])/g, function (g) {
                        return g[1].toUpperCase();
                    }) + 'First'}>

                    {this.state.planId === this.state.selectedPlanId ? 'Current Plan' : 'Get Started'}
                    {this.state.spinnerActive && this.state.spinnerActivePlan === this.state.planId ?
                        <i className='fa fa-spin fa-spinner'></i>
                        : ''
                    }
                </button>
                {this.state.planPeriod === 'yearly'
                    ?
                    <div
                        className="bg-green absolute font-semibold text-sm right-4 top-[130px] bg-gray-50 text-white border border-discountBorder py-1 px-3 rounded-md">
                        <span className="text-lightText">SAVE</span> <span
                        className="font-bold text-[17px]  text-discountRed text-opacity-50">${this.renderSaveSwitch(this.state.planName)}</span>
                    </div>
                    : ''
                }
            </div>
        )
    }
}

export default PlanHeader;